(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const initCurrencyWatcher = () => {
    const cartDrawer = document.querySelector('.cart-drawer'); // adjust if needed
    const display = document.querySelector('.bucks-selected');

    if (!cartDrawer || !display) {
      console.log('[Currency] ❌ Missing cartDrawer or display');
      return false;
    }

    console.log('[Currency] ✅ Initialized with display:', display);

    function applyCurrencyClass(rawValue) {
      const value = rawValue.toUpperCase().trim();

      console.log('[Currency] 🔄 Applying:', value);

      cartDrawer.classList.remove('rs', 'bih', 'me');

      if (value.includes('RSD')) {
        console.log('[Currency] 🇷🇸 rs');
        cartDrawer.classList.add('rs');
      } else if (value.includes('BAM')) {
        console.log('[Currency] 🇧🇦 bih');
        cartDrawer.classList.add('bih');
      } else if (value.includes('EUR')) {
        console.log('[Currency] 🇲🇪 me');
        cartDrawer.classList.add('me');
      } else {
        console.log('[Currency] ⚠️ Unknown:', value);
      }

      console.log('[Currency] 📦 Classes now:', cartDrawer.className);
    }

    // ✅ Initial run
    applyCurrencyClass(display.textContent);

    // ✅ Watch visible value change
    const textObserver = new MutationObserver(() => {
      console.log('[Currency] 🔁 Text changed:', display.textContent);
      applyCurrencyClass(display.textContent);
    });

    textObserver.observe(display, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // ✅ Listen for clicks on dropdown options
    document.addEventListener('click', (e) => {
      const option = e.target.closest('.converterTriggers');
      if (!option) return;

      const val = option.getAttribute('rel') || option.id || option.textContent;

      console.log('[Currency] 🖱 Click detected:', val);

      // small delay so UI updates first
      setTimeout(() => {
        applyCurrencyClass(val);
      }, 50);
    });

    return true;
  };

  // Wait for widget to load
  const wait = setInterval(() => {
    if (initCurrencyWatcher()) {
      clearInterval(wait);
    }
  }, 100);
  } catch(e) { console.error(e); }
})();

})();
